import { render, staticRenderFns } from "./IconRefund.vue?vue&type=template&id=e2565bf8&"
import script from "./IconRefund.vue?vue&type=script&lang=js&"
export * from "./IconRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports